function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgMxn = function SvgMxn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M512,256c0-101.494-59.065-189.19-144.696-230.598v461.195C452.935,445.19,512,357.494,512,256z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M0,256c0,101.494,59.065,189.19,144.696,230.598V25.402C59.065,66.81,0,154.506,0,256z"
  }), React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M189.217,256c0,36.883,29.9,66.783,66.783,66.783s66.783-29.9,66.783-66.783v-22.261H189.217V256z"
  })), React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M345.043,211.478h-66.783c0-12.294-9.967-22.261-22.261-22.261s-22.261,9.967-22.261,22.261h-66.783 c0,12.295,10.709,22.261,23.002,22.261h-0.741c0,12.295,9.966,22.261,22.261,22.261c0,12.295,9.966,22.261,22.261,22.261h44.522 c12.295,0,22.261-9.966,22.261-22.261c12.295,0,22.261-9.966,22.261-22.261h-0.742C334.335,233.739,345.043,223.773,345.043,211.478 z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMxn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MXN.6ee1e6d4.svg";
export { ForwardRef as ReactComponent };